module.exports = __webpack_public_path__ + "static/media/bronze_link_banner_ja.e01cd212.png";